
import { MemoryRouter as Router, Route, Routes } from "react-router-dom";
import { StateMachineProvider, createStore } from "little-state-machine";
import Step1 from "./Step1/index";
import Step2 from "./Step2/index";
import Step3 from "./Step3/index";
import Step4 from "./Step4/index";
import Step2b from "./Step2b/index";
import Step3b from "./Step3b/index";
import Receipt from "./Receipt/index";
import Step5 from "./Step5";
import Step4b from "./Step4b/index";
import { AnimatePresence } from "framer-motion";
import TradeWasteContext, { initialState, reducer } from "./tradeWasteContext";
import { useReducer } from "react";

createStore({
  data: {
    trade_waste_application_type: "",
    other: void 0,
    permit_number: "",
    trade_waste_change: "",
    unit_shop_number: "",
    street_number: "",
    street_name: "",
    nearest_intersection: "",
    suburb: "",
    postcode: "",
    building_shopping_centre_name: "",
    name: "",
    number: "",
    email: "",
    business_trading_name: "",
    date_of_change: "",
    abn: "",
    company_name: "",
    operator_name: "",
    operator_position: "",
    operator_number: "",
    operator_email: "",
    date_of_discharge: "",
    mailing_same: "",
    description: "",
    cooking_on_premises: "",
    connecting_existing_grease_arrestor: "",
    connecting_new_grease_arrestor: "",
    fitouts_additional_plumbing: "",
    business_hours: [{ day: "", from: "", to: "" }],
    contacts: [{ name: "", relationship: "", number: "" }],
    "Apply for a trade waste permit": void 0,
    mailing_address: "",
    mailing_suburb: "",
    mailing_postcode: void 0,
    seating_capacity: void 0,
    kitchen_sink: void 0,
    double_kitchen_sink: void 0,
    pot_sink: void 0,
    double_pot_sink: void 0,
    hand_basin: void 0,
    wok_burners: void 0,
    combi_ovens: void 0,
    existing_arrestor_barcode: "",
    existing_arrestor_location: "",
    existing_arrestor_size: void 0,
    existing_arrestor_shared: "",
    new_arrestor_size: void 0,
    new_arrestor_make_model: '',
    new_arrestor_licensed_plumber_name: "",
    new_arrestor_licensed_plumber_contact: void 0,
    new_arrestor_install_date: "",
    declaration_name: "",
    declaration_position: '',
    declaration_company_name: '',
    declaration_phone: void 0,
    declaration_email: '',
    declaration_confirm: ''
  },
  uploads: {
    menu: [],
    plumbing_plan: []
  }
});

function TradeWaste({ endpoint, blankAppUrl, sharedGreaseFormUrl, oneOffDischargeFormUrl, termsConditionsUrl, legalUrl, moreInformationUrl, emailAddress }:
  {
    endpoint: string, blankAppUrl: string, sharedGreaseFormUrl: string, oneOffDischargeFormUrl: string,
    termsConditionsUrl: string, legalUrl: string, moreInformationUrl: string, emailAddress: string
  }) {

  return (
    <TradeWasteContext.Provider value={useReducer(reducer,
      { ...initialState, endpoint, blankAppUrl, sharedGreaseFormUrl, oneOffDischargeFormUrl, termsConditionsUrl, legalUrl, moreInformationUrl, emailAddress })}>
      <StateMachineProvider>
        <section style={{ width: "100%" }}>
          <Router>
            <AnimatePresence>
              <Routes>

                <Route path="/">
                  <Route path="step2" element={<Step2 />} />
                  <Route path="step3" element={<Step3 />} />
                  <Route path="step4" element={<Step4 />} />
                  <Route path="step5" element={<Step5 endpoint={endpoint} />} />
                  <Route path="step2b" element={<Step2b />} />
                  <Route path="step3b" element={<Step3b />} />
                  <Route path="step4b" element={<Step4b endpoint={endpoint} />} />
                  <Route path="receipt" element={<Receipt />} />
                  <Route index element={<Step1 />} />
                  <Route path="*" element={<Step1 />} />
                </Route>
              </Routes>
            </AnimatePresence>
          </Router>
        </section>
      </StateMachineProvider>
    </TradeWasteContext.Provider>
  );
}
export default TradeWaste